import { CheckCircle2, Circle, ArrowRight, Info } from "lucide-react";
import { Popover, PopoverTrigger, PopoverContent } from "../ui/popover";

export function Milestone({ i, on, onToggle, onGo }) {
  return (
    <li className="flex items-center gap-1" data-testid={`roadmap-row-${i.id}`}>
      <button onClick={() => onToggle(i.id)} className="flex-1 flex items-center gap-3 py-2 text-left group" data-testid={`roadmap-item-${i.id}`} aria-pressed={on}>
        {on ? <CheckCircle2 className="w-5 h-5 text-green-500 shrink-0" /> : <Circle className="w-5 h-5 text-slate-300 group-hover:text-primary shrink-0" />}
        <span className={`text-sm ${on ? "text-slate-400 line-through" : "text-slate-700"}`}>{i.text}</span>
        {i.credited && on && <span className="text-[10px] font-bold uppercase tracking-wider text-green-700 bg-green-50 px-1.5 py-0.5 rounded" data-testid={`roadmap-credited-${i.id}`}>You have this</span>}
        {!i.counts && <span className={`text-[10px] font-bold uppercase tracking-wider px-1.5 py-0.5 rounded ${i.badge ? "text-amber-800 bg-amber-100" : "text-slate-400 bg-slate-100"}`} data-testid={`roadmap-optional-${i.id}`}>{i.badge || (i.optional ? "Optional" : "If applicable")}</span>}
      </button>
      {i.link && <button onClick={() => onGo(i.link)} className="inline-flex items-center gap-1 text-xs font-semibold text-slate-400 hover:text-primary shrink-0 px-1.5 py-1 rounded-md hover:bg-primary/5 transition-colors" data-testid={`roadmap-item-link-${i.id}`}>{i.link_label} <ArrowRight className="w-3 h-3" /></button>}
      {i.tip && (
        <Popover>
          <PopoverTrigger asChild>
            <button className="w-7 h-7 rounded-full flex items-center justify-center text-primary hover:text-red-700 hover:bg-primary/10 shrink-0" title="What is this?" data-testid={`roadmap-tip-${i.id}`}><Info className="w-4 h-4" /></button>
          </PopoverTrigger>
          <PopoverContent side="right" align="start" className="w-80 text-sm leading-relaxed text-slate-700" data-testid={`roadmap-tip-content-${i.id}`}>
            <p className="text-[11px] font-bold uppercase tracking-wider text-primary mb-1.5">{i.text}</p>{i.tip}
          </PopoverContent>
        </Popover>
      )}
    </li>
  );
}

export function PhaseInfo({ phase }) {
  const a = phase.about;
  if (!a) return null;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" onClick={(e) => e.stopPropagation()} className="w-7 h-7 rounded-full flex items-center justify-center text-primary hover:text-red-700 hover:bg-primary/10 shrink-0" title="About this step" data-testid={`roadmap-phase-info-${phase.id}`}><Info className="w-4 h-4" /></button>
      </PopoverTrigger>
      <PopoverContent side="right" align="start" onClick={(e) => e.stopPropagation()} className="w-80 text-sm leading-relaxed text-slate-700 space-y-2" data-testid={`roadmap-phase-info-content-${phase.id}`}>
        <p className="text-[11px] font-bold uppercase tracking-wider text-primary">{phase.title}</p>
        {[["What it is", a.what], ["Why it matters", a.why], ["Focus on", a.focus]].map(([k, v]) => <div key={k}><p className="text-[10px] font-bold uppercase tracking-wider text-slate-400">{k}</p><p>{v}</p></div>)}
      </PopoverContent>
    </Popover>
  );
}
